/* Flynker built-in wishlist (replaces the Swym app embed). Saved in this browser only (localStorage). */
(function () {
  var KEY = 'flynker_wishlist_v1';
  var MAX = 60;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }
  function has(list, handle) {
    for (var i = 0; i < list.length; i++) if (list[i].handle === handle) return true;
    return false;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function syncButtons() {
    var list = read();
    document.querySelectorAll('[data-fw-toggle]').forEach(function (btn) {
      var on = has(list, btn.getAttribute('data-handle'));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
    document.querySelectorAll('[data-fw-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  var toastTimer;
  function toast(msg) {
    var t = document.getElementById('FwToast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2200);
  }

  function renderDrawer() {
    var body = document.getElementById('FwDrawerBody');
    if (!body) return;
    var list = read();
    if (!list.length) {
      body.innerHTML = '<p class="fw-empty">Your wishlist is empty. Tap the ♡ on any product to save it here.</p>';
      return;
    }
    body.innerHTML = list.map(function (p) {
      return '<div class="fw-item">' +
        '<a href="' + esc(p.url) + '" class="fw-item__img">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="80" height="107" loading="lazy">' : '') + '</a>' +
        '<div class="fw-item__info"><a href="' + esc(p.url) + '" class="fw-item__title">' + esc(p.title) + '</a>' +
        '<div class="fw-item__price">' + esc(p.price) + '</div>' +
        '<a href="' + esc(p.url) + '" class="fw-item__view">View product</a></div>' +
        '<button type="button" class="fw-item__remove" data-fw-remove="' + esc(p.handle) + '" aria-label="Remove ' + esc(p.title) + '">×</button>' +
        '</div>';
    }).join('');
  }

  function openDrawer() {
    var d = document.getElementById('FwDrawer');
    if (!d) return;
    renderDrawer();
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    document.body.classList.add('fw-lock');
    var close = d.querySelector('.fw-drawer__close');
    if (close) close.focus();
  }
  function closeDrawer() {
    var d = document.getElementById('FwDrawer');
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.body.classList.remove('fw-lock');
    setTimeout(function () { d.hidden = true; }, 250);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fw-toggle]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var list = read();
      var handle = btn.getAttribute('data-handle');
      if (has(list, handle)) {
        list = list.filter(function (p) { return p.handle !== handle; });
        toast('Removed from wishlist');
      } else {
        list.unshift({
          handle: handle,
          title: btn.getAttribute('data-title'),
          url: btn.getAttribute('data-url'),
          img: btn.getAttribute('data-img'),
          price: btn.getAttribute('data-price')
        });
        toast('Added to wishlist ♥');
      }
      write(list);
      syncButtons();
      return;
    }
    var rm = e.target.closest('[data-fw-remove]');
    if (rm) {
      var h = rm.getAttribute('data-fw-remove');
      write(read().filter(function (p) { return p.handle !== h; }));
      syncButtons();
      renderDrawer();
      return;
    }
    if (e.target.closest('[data-fw-open]')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-fw-close]')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  // Keep hearts in sync across tabs and on content loaded later (quick add, filters, recommendations).
  window.addEventListener('storage', function (e) { if (e.key === KEY) syncButtons(); });
  var syncQueued = false;
  new MutationObserver(function () {
    if (syncQueued) return;
    syncQueued = true;
    setTimeout(function () { syncQueued = false; syncButtons(); }, 300);
  }).observe(document.body, { childList: true, subtree: true });

  // Old Swym links (/#swym-list, /pages/swym-wishlist) open the new drawer instead.
  if (location.hash === '#swym-list' || location.hash === '#wishlist' || location.pathname.indexOf('/pages/swym') === 0) openDrawer();

  syncButtons();
})();
